/**
 * Token storage interface
 * Platform-agnostic storage contract
 */
export const STORAGE_KEYS = {
    ACCESS_TOKEN: "fmc_access_token",
    ID_TOKEN: "fmc_id_token",
    REFRESH_TOKEN: "fmc_refresh_token",
    EXPIRES_AT: "fmc_expires_at",
    TOKEN_TYPE: "fmc_token_type",
};
//# sourceMappingURL=tokenStorage.js.map